<template>
  <div class="full-height menu">
    <w-loading v-if="gettingMenu || !isValid" color="primary-500" />
    <section v-else>
      <menu-top-infos
        :show-auth-infos="!hasShareKey"
        :infos="infos"
        :member-orders="orders"
        :time-periods="periods"
      />
      <div class="menu__sticky-block">
        <section
          v-if="hasShareKey"
          class="bg-light-gray-400 justify-center menu__news sm:flex-col"
          ref="news"
        >
          <span class="text-primary-500">
            哈囉！歡迎加入此團購！
          </span>
          <span v-if="consumptionLimitText" class="ml-2 sm:ml-0 text-secondary-500">
            ({{ consumptionLimitText }})
          </span>
        </section>
        <section
          v-else-if="showNews"
          class="bg-secondary-100 flex-col justify-between menu__news text-secondary-500"
          ref="news"
        >
          <span
            v-for="news in newsList"
            :key="`news-${news}`"
            :title="news"
          >
            {{ news }}
          </span>
        </section>
        <div class="menu__scrollbar" id="menu-scrollbar">
          <div class="weiby-container">
            <ul class="flex items-center px-6 text-primary-500 text-sm w-max">
              <li
                v-for="category in categories"
                :id="`scroll-tab-${category.index}`"
                :key="category.name"
                :data-active="activatedCategory === `menu-category-${category.index}`"
                class="menu__scrollbar--item"
                @click="scrollTo(category.index)"
              >
                {{ category.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <menu-items
        v-if="items.length"
        :items="items"
        :entree-limit="menu.entree_limit"
        @click="showMenuItemDetails"
      />
      <menu-item-details
        :is-scheduled="isScheduled"
        :expected-start-period="expectedStartPeriod[0]"
        v-model="showDetails"
        @close="showDetails = false"
      />
    </section>
    <button
      v-if="$breakpoints.sm && hasCartItems"
      class="menu__view-cart--button"
      id="mobile-show-cart-btn"
      @click="showCart"
    >
      <span class="border border-white px-2 py-1 rounded-sm text-sm">
        {{ cartItemsCount }}
      </span>
      <span>查看購物車</span>
      <span class="text-sm">{{ cartTotal | commaFormat | priceFormat }}</span>
    </button>
    <continue-share-link v-model="showContinueShareLinkModal" />
  </div>
</template>

<script>
import Menu from './Menu';

export default Menu;
</script>

<style lang="scss" scoped>
@import 'Menu';
</style>
